import React from 'react'

function Done({ operation, onReturn }) {
  return (
    <div className="done-stage">
      <div className="done-card">
        <div className="done-check">✓</div>
        <h3>Operacja zakończona</h3>
        <p className="done-operation">{operation.name}</p>
        <div className="done-summary">
          <div className="f_group"><label>Zlecenie</label><div>{operation.production_name}</div></div>
          <div className="f_group"><label>Zaplanowano</label><div>{operation.qty_production} szt.</div></div>
          <div className="f_group f_group--big"><label>Wykonano</label><div>{operation.qty_produced} szt.</div></div>
          <div className="f_group"><label>Odpady</label><div>{operation.qty_waste} szt.</div></div>
        </div>
        {operation.manual_close_required && (
          <div className="op-warning">
            ⚠ Zlecenie {operation.production_name} wymaga numeru partii lub numerów seryjnych
            — zostanie zamknięte w ERP.
          </div>
        )}
        <button type="button" className="block" onClick={onReturn}>Wróć do listy operacji</button>
      </div>
    </div>
  )
}

export default Done
